import { render, staticRenderFns } from "./LineItem.vue?vue&type=template&id=6b4a8d02&"
import script from "./LineItem.vue?vue&type=script&lang=js&"
export * from "./LineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/buddy/magculture/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4a8d02')) {
      api.createRecord('6b4a8d02', component.options)
    } else {
      api.reload('6b4a8d02', component.options)
    }
    module.hot.accept("./LineItem.vue?vue&type=template&id=6b4a8d02&", function () {
      api.rerender('6b4a8d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/FlyoutCart/LineItem.vue"
export default component.exports